export const companies = [
  {
    id: 1,
    name: 'Healthcare Practice Platform',
    tagline: 'Multi-clinic practice management SaaS',
    description: 'Re-architected a legacy monolith into domain-driven, service-oriented modules, improving scalability and maintainability.',
    thumbnail: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    category: 'Healthcare Tech',
    role: 'Principal Software Engineer',
    period: 'May 2024 - October 2025',
    technologies: ['Laravel', 'PHP 8.3', 'React', 'TypeScript', 'AWS'],
    metric: 'Zero-downtime deployments achieved'
  },
  {
    id: 2,
    name: 'Social Discovery Platform',
    tagline: 'High-traffic consumer social platform',
    description: 'Led serverless architecture and drove cost-savings initiatives across AWS reserved capacity and infrastructure.',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800&q=80',
    category: 'Social Platform',
    role: 'Technical Lead (Typescript)',
    period: 'July 2021 - March 2024',
    technologies: ['TypeScript', 'Serverless', 'AWS Lambda', 'Datadog'],
    metric: '40% cost savings via infrastructure optimization'
  },
  {
    id: 5,
    name: 'Consumer Dating Marketplace',
    tagline: 'Payments-heavy consumer marketplace',
    description: 'Integrated four payment gateways and built payment APIs transacting >$100k gross revenue per day.',
    thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    category: 'Social Platform',
    role: 'Technical Lead (Payments)',
    period: 'January 2020 - July 2021',
    technologies: ['Stripe', 'PayPal', 'Laravel', 'PHP 8.x'],
    metric: '>$100k daily transaction processing'
  },
  {
    id: 6,
    name: 'Car Rental Comparison Platform',
    tagline: 'Travel tech comparison marketplace',
    description: 'Led development of a car rental comparison marketplace on Laravel, React, AngularJS, and AWS.',
    thumbnail: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800&q=80',
    category: 'Travel Tech',
    role: 'Development Team Leader',
    period: 'March 2015 - November 2017',
    technologies: ['Laravel', 'React', 'AngularJS', 'AWS'],
    metric: 'Promoted to Team Leader in 6 months'
  }
]

export const getCompaniesByCategory = (category) => {
  return companies.filter(company => company.category === category)
}

export const getAllCategories = () => {
  return [...new Set(companies.map(company => company.category))]
}
